module.exports = __webpack_public_path__ + "static/media/money-bill.23972ea0.svg";